import React from "react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IShortcut } from "./navbar-shortcuts";
import { Button } from "..";

export const Shortcut = (props: IShortcut) => {
    const { url, label, icon } = props;

    let isActive = false;
    const { t } = useTranslation();

    if (window.location.pathname == "/" && url == "/") {
        isActive = true;
    } else {
        isActive = url[1] ? window.location.pathname == url : false;
    }

    return (
        <li className="navbar-shortcut" title={t(label)}>
            <Link to={url}>
                <Button withoutPerm outline={!isActive} color="secondary" text={t(label)} icon={icon ? { name: icon } : undefined} />
                {/* below is the old stylized navbar shortcut, looks more like yaybar links */}
                {/* <span style={{display:"inline"}} className={`${ i == 0 ? 'ml-7' : ''} btn btn-custom-round nav-link mr-10 ${ isActive ? 'active-shortcut' : '' }`}>
                        <Icon name={ s.icon || ['fas', 'layer-group'] } />
                    </span>
                    <span style={{display:"inline"}} className={`nav-link nav-shortcut-label ${ isActive ? 'active-shortcut' : '' }`}> 
                        { this.translateName(s.name) }
                    </span> */}
            </Link>
        </li>
    );
};
